import { useCallback, useMemo } from 'react';
import useInfiniteFetch from '../useInfiniteFetch';
import useSubscribeStorage from '../../hooks/useSubscribeStorage';
import { DEFAULT_ENVIRONMENT_ID } from 'src/constants/storage';
import { WDAC_CATALOG_INVENTORY_DEVICES_KEY } from 'src/constants/query';
import { EXPANDED_ROWS_LIMIT } from 'src/constants/table';
import useQueryParams from '../../hooks/useQueryParams';
import { parseQueryToApiQuery } from 'src/utils/query.utils';
import { useParams } from 'react-router-dom';
import CatalogInventoryService from '../../services/catalog-inventory.service';

const useGetCatalogInventorySectionDevices = () => {
  const customerEnvId = useSubscribeStorage(DEFAULT_ENVIRONMENT_ID);
  const { deviceId } = useParams();
  const {
    queryObject: { searchValue: initialSearchValue, filters = {} },
  } = useQueryParams();

  const query = useMemo(
    () =>
      parseQueryToApiQuery({
        filters,
        searchValue: initialSearchValue,
      }),
    [filters, initialSearchValue],
  );

  const fetchFunction = useCallback(
    ({ page, limit }) =>
       CatalogInventoryService.getCatalogInventoryDeviceAll({
        limit,
        page,
        deviceId,
        customerEnvId,
        query,
      }),
    [deviceId, customerEnvId, query],)

  const response = useInfiniteFetch({
    queryKey: [WDAC_CATALOG_INVENTORY_DEVICES_KEY, query, customerEnvId, deviceId],
    fetchFunction,
    expandedRowsLimit: EXPANDED_ROWS_LIMIT,
    itemName: 'catalogInventories',
  });
  return {
    ...response,
    query,
  };
};

export default useGetCatalogInventorySectionDevices;
